import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CommentThread } from "@/components/security/CommentThread";
import { CommentForm } from "@/components/security/CommentForm";
import { useIssueComments } from "@/hooks/useIssueComments";
import { useOrganizationContext } from "@/providers/OrganizationProvider";

interface CommentsTabProps {
  numericIssueId: number;
  commentCount: number;
}

export function CommentsTab({ numericIssueId, commentCount }: CommentsTabProps) {
  const { data: commentsResponse } = useIssueComments(numericIssueId);
  const { user, isOrganizationOwner } = useOrganizationContext();

  return (
    <div className="mt-6 space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Comments{commentCount > 0 ? ` (${commentCount})` : ""}</CardTitle>
        </CardHeader>
        <CardContent>
          <CommentThread
            comments={commentsResponse?.data ?? []}
            issueId={numericIssueId}
            currentUserId={user?.id}
            isOrgOwner={isOrganizationOwner}
          />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Add a Comment</CardTitle>
        </CardHeader>
        <CardContent>
          <CommentForm issueId={numericIssueId} />
        </CardContent>
      </Card>
    </div>
  );
}
